<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title='"周年庆生，蛋糕狂欢"'></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-td' v-show='preloadingShow'></div>
    </transition>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>
    <MySwiper :noSwiperClass='noSwiperClass' ref="mySwiper">
      <template v-slot:first-slide-content>
        <div class='home-page swiper-no-swiping'>
          <Header
            v-if='true'
            :config='headerConfig'
            :isShowInfo='true' />
          <div class="logo">
            <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
              <img v-show="titleShow" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/logo.png"/>
            </transition>
          </div>
          <div class="title">
            <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
              <img v-show="titleShow" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/title.png"/>
            </transition>
          </div>
          <div class="menu_btn" @click="openPopup('detailShow')"></div>
          <div class="group_btn" @click="goJoinGroup()"></div>
          <div class="reward_btn" @click="openPopup('rewardShow')"></div>
          <div class="invite_btn" v-if="activeInfo.times === 0" @click="onInvite()">
            <!-- <div class="invite_tips" v-if="activeInfo.is_share === false"></div> -->
          </div>
          <div :class="'play_btn ' + (activeInfo.times === 0 ? 'play_btn_none' : '')" @click="onPlay()">
            <p>剩余次数：{{activeInfo.times || 0}}</p>
          </div>

          <div class="firework-container">
            <div class="firework-fir"></div>
            <div class="firework-sec"></div>
            <div class="firework-thr"></div>
            <div class="firework-four"></div>
          </div>

          <!-- 分享相关DOM -->
          <div class="share-box" ref="imageDom">
            <img src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/share_popup.png"/>
            <div class="share-img">
              <div class="qrcode-box">
                <div id="qrcode" class="qrcode"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:second-slide-content>
        <div class='content-page'>
          <div class='active-content'>

            <div class="light"></div>

            <div class="cake"></div>

            <div class="paly_box"></div>

            <div class="tips">
              <div :class="'role role-' + roleId  + (showRole ? '' : ' role_hide')"></div>
              <img v-show="titleShow" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/role_tips.png"/>
            </div>

            <div :class="'progress_box ' + (showRole ? '' : 'role_hide')" ref="progressBox">
              <div :class="'knife knife_' + roleId + (aniStop ? ' knife_stop' : '')" ref="knife"></div>
              <div :class="'progress_bar progress_bar_' + roleId"></div>
            </div>

            <div class="cake_btn" v-if="showRole" @click="cutCake()"></div>
          </div>
          <Footer :gameName="gameName" />
        </div>
      </template>
    </MySwiper>

    <!-- 弹窗类 -->
    <!-- 活动详情 -->
    <div class="detail_wrap popup_wrap" v-if="detailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
         <div class="detail_box popup_wrap_box" v-show="detailShow" @click="closePopup('detailShow')"></div>
      </transition>
      <div class="close-bg" v-show="detailShow" @click="closePopup('detailShow')"></div>
    </div>
    <!-- 奖励列表 -->
    <div class="reward_wrap popup_wrap" v-if="rewardShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="reward_box popup_wrap_box" v-show="rewardShow">
          <div class="cake_total"><span>{{activeInfo.total_score || 0}}</span></div>
          <ul>
            <li class="acquire_1" v-if="activeInfo.is_share"></li>
            <li class="acquire_2" v-if="activeInfo.reward_list && activeInfo.reward_list[0]"></li>
            <li class="acquire_3" v-if="activeInfo.reward_list && activeInfo.reward_list[1]"></li>
            <li class="acquire_4" v-if="activeInfo.reward_list && activeInfo.reward_list[2]"></li>
            <li class="acquire_5" v-if="activeInfo.reward_list && activeInfo.reward_list[3]"></li>
            <li class="acquire_6" v-if="activeInfo.reward_list && activeInfo.reward_list[4]"></li>
          </ul>
        </div>
      </transition>
      <div class="close-bg" v-show="rewardShow" @click="closePopup('rewardShow')"></div>
    </div>
    <!-- 获取蛋糕 -->
    <div class="harvest_cake_wrap popup_wrap" v-if="harvestCakeShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="harvest_cake_box popup_wrap_box" v-show="harvestCakeShow">
          <p>恭喜！本次切得<b>蛋糕{{ score }}块</b>！</p>
          <div class="back_btn" @click="goBackToFirstSwiper()"></div>
          <div class="continue_btn" @click="onContinue()">
            <span>剩余次数：{{activeInfo.times || 0}}</span>
          </div>
        </div>
      </transition>
      <!-- <div class="close-bg" v-show="harvestCakeShow" @click="onPrevSwiper()"></div> -->
    </div>
    <!-- 次数不足 -->
    <div class="lack_times_wrap popup_wrap" v-if="lackTimesShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
         <div class="lack_times_box popup_wrap_box" v-show="lackTimesShow" @click="closePopup('lackTimesShow')"></div>
      </transition>
      <div class="close-bg" v-show="lackTimesShow" @click="closePopup('lackTimesShow')"></div>
    </div>
    <!-- 邀请弹窗 -->
    <div class="help-share-wrap popup_wrap" v-if="shareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="help-share-box popup_wrap-box" v-show="shareShow">
          <img :src="shareImg" alt="分享图片" />
          <button class="monitor-btn" @click="onCopy()" id="clipboard-btn" data-event="复制邀请链接"
            :data-clipboard-text="'提灯二周年联动进行中！切蛋糕得好礼，快来帮我助力吧~  ' + shareLink"></button>
          <div class="close-bg" v-show="shareShow" @click="closePopup('shareShow')"></div>
        </div>
      </transition>
    </div>
    <!-- 硬币动画 -->
    <div class="coin_ani_wrap popup_wrap" v-if="coinAniShow">
      <div class="coin_ani_box">
        <div :class="'coin_ani coin_ani_' + roleId"></div>
      </div>
    </div>
    <!-- 新手引导 -->
    <div class="guide_wrap popup_wrap" v-if="needGuide">
      <div class="popup_wrap"></div>
      <div class="guide_box" @click="nextGuide()">
        <div class="step_1" v-if="step[0]">
          <ul>
            <li>
              <transition enter-active-class="animated fadeInUp coin coin_1" leave-active-class="animated fadeOutDown coin coin_1">
                <img v-show="coin[0]" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/guide/coin_1.png"/>
              </transition>
            </li>
            <li>
              <transition enter-active-class="animated fadeInUp coin coin_2" leave-active-class="animated fadeOutDown coin coin_1">
                <img v-show="coin[0]" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/guide/coin_2.png"/>
              </transition>
            </li>
            <li>
              <transition enter-active-class="animated fadeInUp coin coin_3" leave-active-class="animated fadeOutDown coin coin_1">
                <img v-show="coin[0]" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/guide/coin_3.png"/>
              </transition>
            </li>
          </ul>
        </div>
        <div class="step_2" v-show="step[1]">
          <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <img v-show="step[1]" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/guide/dialog_1.png"/>
          </transition>
        </div>
        <div class="step_3" v-show="step[2]">
          <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <img v-show="step[2]" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/guide/dialog_2.png"/>
          </transition>
        </div>
        <div class="step_4" v-show="step[3]">
          <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <img v-show="step[3]" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/guide/dialog_3.png"/>
          </transition>
        </div>
        <div class="step_5" v-show="step[4]">
          <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <img v-show="step[4]" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/guide/progress.png"/>
          </transition>
          <ul>
            <li class="cake_1">
              <transition enter-active-class="animated fadeInUp cake_ani_1" leave-active-class="animated fadeOutDown cake_ani_1">
                <img v-show="cake[0]" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/guide/cake_1.png"/>
              </transition>
            </li>
            <li class="cake_2">
              <transition enter-active-class="animated fadeInUp cake_ani_2" leave-active-class="animated fadeOutDown cake_ani_2">
                <img v-show="cake[1]" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/guide/cake_2.png"/>
              </transition>
            </li>
            <li class="cake_3">
              <transition enter-active-class="animated fadeInUp cake_ani_3" leave-active-class="animated fadeOutDown cake_ani_3">
                <img v-show="cake[2]" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/guide/cake_3.png"/>
              </transition>
            </li>
          </ul>
        </div>
        <div class="ok_btn" v-show="confirmGuide" @click="closeGuide()">
          <transition enter-active-class="animated fadeInUp coin coin_3" leave-active-class="animated fadeOutDown coin coin_1">
            <img v-show="confirmGuide" src="https://download4.qcplay.com/h5-images/active/tideng/anniversary/guide/ok_btn.png"/>
          </transition>
        </div>
      </div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import Clipboard from 'clipboard';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MySwiper from '@/components/MySwiper';
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI, submitGameData, getPlayKey, changeShareStatus, changeGuideStatus } from '../api';
import { getRandomString, buriedLogger } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';

const INTERVAL_CONFIG = {
  1: [[39.5, 58.5], [48.0, 51]],
  2: [[37.2, 61.5], [47, 52.7]],
  3: [[34.7, 68.5], [48.0, 55.6]]
};

export default {
  name: 'anniversary',
  components: {
    Header,
    Footer,
    Login,
    Os,
    MySwiper
  },
  data () {
    return {
      headerConfig,
      gameName: 'tideng',
      downloadUrl: 'https://static.qcplay.com/tideng/official/',
      preloadingShow: true,
      titleShow: true,
      noSwiperClass: '', // swiper-no-swiping
      shareLink: '',
      shareImg: null,
      shareShow: false,
      preventShow: false,
      swiper: null,
      logger: null,

      // 新手引导相关
      needGuide: false,
      guideIdx: 0,
      isNextGuide: false,
      confirmGuide: false,
      step: [],
      coin: [],
      cake: [],

      // 业务弹窗
      detailShow: false,
      rewardShow: false,
      harvestCakeShow: false,
      lackTimesShow: false,
      coinAniShow: false,

      score: 0,
      orderId: null,
      roleId: null,
      showRole: false,
      aniStop: true
    };
  },
  created () {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    setTimeout(() => {
      this.mySwiper();
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
        this.preloadingShow = false;
      });
    }, 100);

    // 埋点
    const bl = buriedLogger('tideng', '周年庆H5活动_首页');
    this.logger = bl;

    this.setShare({
      title: '周年庆生，蛋糕狂欢',
      desc: '提灯二周年联动进行中！帮五郎切得更多蛋糕，即可获得丰厚游戏奖励哦~',
      imgUrl: 'https://download4.qcplay.com/tideng/active/anniversary_share_image_m.jpg'
    });
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        console.log('newValue', newValue);
        console.log('oldValue', oldValue);
        if (!newValue.user_id) {
          // TAG: 注销的时候
          this.orderId = null;
          this.roleId = null;
          this.shareLink = '';
          this.shareImg = null;
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          if (this.activeInfo.order && this.activeInfo.order.order_id) {
            this.orderId = this.activeInfo.order.order_id;
            this.roleId = this.activeInfo.order.data;
            this.$nextTick(() => {
              this.$refs.mySwiper.nextSwiper(1);
            });
            this.showRole = true;
            this.aniStop = false;
          } else {
            this.orderId = null;
            this.roleId = null;
          }
          const { protocol, host } = window.location;
          this.shareLink = `${protocol}//${host}/tideng/anniversary/help${getRandomString()}?id=${newValue.user_id}`;
          this.initShareData(newValue);
        }
      }
    }
  },
  methods: {
    initShareData (info) {
      this.qrcode(`${this.shareLink}?id=${info.user_id}`);
      this.$nextTick(() => {
        this.generateShareImage();
      });
    },
    qrcode (link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#ba4e31',
        colorLight: '#ffe0af'
      });
    },
    // 分享图片设置
    generateShareImage () {
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
        })
        .catch((err) => {
          console.log('err: 图片生成失败', err.message);
        });
    },
    // 复制链接
    onCopy () {
      const clipboard = new Clipboard('#clipboard-btn');
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });

      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
      this.logger.sum('anniversary_copy_link');
    },
    // swiper轮播
    mySwiper () {
      this.$refs.mySwiper.init({
        allowSlidePrev: false,
        on: { init: swiper => { this.swiper = swiper; } }
      });
    },
    // 选择角色后
    selectCallback () {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
      });
    },
    // 区组弹窗注销-相关参数复位
    osCancell () {},
    // TAG: 相关业务方法
    onInvite () {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
      this.shareShow = true;
      if (this.activeInfo.is_share === false) {
        changeShareStatus();
        this.setActiveInfo({ ...this.activeInfo, is_share: true });
      }
      this.logger.sum('周年庆H5活动_邀请好友');
    },
    // 新手引导
    noviceGuide () {
      this.needGuide = true;
      this.step[0] = true;
      setTimeout(() => {
        this.coin = [true, true, true];
      }, 200);
      setTimeout(() => {
        this.isNextGuide = true;
      }, 1400);
    },
    nextGuide () {
      if (!this.isNextGuide || this.guideIdx > 5) {
        return false;
      }
      const guideIdx = this.guideIdx + 1;
      if (guideIdx === 4) {
        setTimeout(() => {
          this.cake = [true, true, true];
        }, 1000);
        setTimeout(() => {
          this.isNextGuide = true;
          this.confirmGuide = true;
        }, 2000);
      } else if (guideIdx === 5) {
        this.closeGuide();
        setTimeout(() => {
          this.isNextGuide = true;
        }, 800);
      } else {
        setTimeout(() => {
          this.isNextGuide = true;
        }, 800);
      }
      this.isNextGuide = false;
      this.$set(this.step, guideIdx, true);
      this.guideIdx = guideIdx;
    },
    closeGuide () {
      this.needGuide = false;
      this.step = [];
      this.cake = [];
      this.coin = [];
      this.confirmGuide = false;
      this.guideIdx = 0;
      this.isNextGuide = false;
      changeGuideStatus();
      this.setActiveInfo({ ...this.activeInfo, is_first: 1 });

      // 游戏key
      this.$nextTick(() => {
        this.preventShow = true;
        this.sendPlayKey();
      });
    },
    openPopup (name) {
      this[name] = true;
      const map = {
        detailShow: '活动详情',
        rewardShow: '奖励礼包'
      };
      if (map[name]) {
        this.logger.sum(`周年庆H5活动_${map[name]}`);
      }
    },
    closePopup (name) {
      this[name] = false;
      if (name === 'lackTimesShow' && !this.activeInfo.times) {
        this.onPrevSwiper();
        this.logger.sum('周年庆H5活动_次数不足返回');
      }
    },
    goJoinGroup () {
      this.logger.sum('周年庆H5活动_加群');
      window.location.href = 'https://static2.qcplay.com/qq_group_jump/index.html?game_id=33';
    },
    // 开始游戏
    onPlay () {
      // 未登录，先登录
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
      // 没有次数
      if (this.activeInfo.times === 0) {
        this.openPopup('lackTimesShow');
        return false;
      }

      this.aniStop = true;
      this.showRole = false;

      // 需要新手指导
      if (this.activeInfo.is_first === 0) {
        this.$refs.mySwiper.nextSwiper(1);
        setTimeout(() => {
          this.noviceGuide();
        }, 200);
        return false;
      }

      if (!this.orderId) { // 订单号不存在，获取订单号
        this.preventShow = true;
        this.sendPlayKey(true);
      } else {
        this.onToast('页面出错了，请刷新页面！');
      }
      this.logger.sum('周年庆H5活动_开始游戏');
    },
    // 获取游戏key
    sendPlayKey (isNextSwiper) {
      getPlayKey()
        .then((response) => {
          const order = response.data.order;
          this.orderId = order.order_id;
          this.roleId = order.data;

          if (isNextSwiper) {
            this.$refs.mySwiper.nextSwiper(1);
          }

          this.startCoinAni();
        })
        .catch(() => {
          this.preventShow = false;
        });
    },
    // 启动硬币动画
    startCoinAni () {
      setTimeout(() => {
        this.coinAniShow = true;
        this.preventShow = false;
      }, 200);
      setTimeout(() => {
        this.coinAniShow = false;
        this.aniStop = false;
        this.showRole = true;
      }, 5000);
    },
    // 确认后返回上一页
    onPrevSwiper () {
      this.orderId = null;
      this.roleId = null;
      this.showRole = false;
      this.closePopup('harvestCakeShow');
      this.swiper.allowSlidePrev = true;
      this.$refs.mySwiper.nextSwiper(0);
      this.$nextTick(() => {
        this.swiper.allowSlidePrev = false;
      });
    },
    // 切蛋糕
    cutCake () {
      this.preventShow = true;
      this.aniStop = true;
      const curInterval = INTERVAL_CONFIG[this.roleId];
      console.log('curInterval', curInterval);
      this.$nextTick(() => {
        setTimeout(() => {
          const width = this.$refs.progressBox.offsetWidth;
          const left = this.$refs.knife.offsetLeft;
          const ratio = (left / width).toFixed(4);
          console.log('width', width, 'left', left, 'ratio', ratio);

          const cakeNum = curInterval.reduce((result, interval) => {
            if (Number(ratio) * 100 > interval[0] && Number(ratio) * 100 < interval[1]) {
              return ++result;
            }
            return result;
          }, 1);
          console.log('cakeNum', cakeNum);
          this.score = cakeNum;

          // 发起api请求
          this.onSubmitGameData({
            order_id: this.orderId,
            score: cakeNum,
            record: `${this.roleId}-${width}-${left}-${ratio}`
          });
        }, 100);
      });
      this.logger.sum('周年庆H5活动_切蛋糕');
    },
    // 提交游戏数据
    onSubmitGameData (data) {
      submitGameData(data)
        .then((response) => {
          console.log(response);
          this.preventShow = false;
          this.openPopup('harvestCakeShow');
          onGetInitDataAPI().then(res => {
            this.onInitDataCallback(res);
          });
        })
        .catch(() => {
          this.preventShow = false;
        });
    },
    // 蛋糕结果弹窗 - 返回
    goBackToFirstSwiper () {
      this.onPrevSwiper();
      this.logger.sum('周年庆H5活动_返回首页');
    },
    // 蛋糕结果弹窗 - 继续
    onContinue () {
      if (!this.activeInfo.times) {
        this.openPopup('lackTimesShow');
        return false;
      }
      this.closePopup('harvestCakeShow');
      this.aniStop = true;
      this.showRole = false;
      this.sendPlayKey();
      this.logger.sum('周年庆H5活动_继续挑战');
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setActiveInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'setShare'
    ])
  }
};
</script>

<style lang='less'>
  @import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/tideng/anniversary/index/index.vue